export default __webpack_public_path__ + "static/media/elza-centrum.b73367a9.jpg";